import Api_Usermanagement from '../api-usermanagement'
const api = new Api_Usermanagement().init()

const getAmandemen = (is_amandement = false) => {
  return api.get(
    `/amandemen/all?credentials=${localStorage.getItem(
      'credential'
    )}&is_amendment=${is_amandement}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const detailAmandemen = (id, is_amandement = false) => {
  return api.get(`/amandemen/detail/${id}?is_amendment=${is_amandement}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const orderDetailAmandemen = (id, is_amandement) => {
  return api.get(
    `/order-submission/detail/${id}?credentials=${localStorage.getItem(
      'credential'
    )}&is_amendment=${is_amandement}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const createAmandemen = (data) => {
  return api.post(`/amandemen/amendment?credentials=${localStorage.getItem('credential')}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const approveAmandemen = (data) => {
  return api.put(`/amandemen/approve?credentials=${localStorage.getItem('credential')}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const rejectAmandemen = (data) => {
  return api.put(`/amandemen/reject?credentials=${localStorage.getItem('credential')}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const detailAmandemenCustomer = () => {
  return api.get(
    `/amandemen/order-detail/${sessionStorage.getItem('po')}?credentials=${localStorage.getItem(
      'credential'
    )}`,
    {
      params: {osd_ids: JSON.parse(sessionStorage.getItem('idarray'))},
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const reviseAmandemen = (data) => {
  return api.put(`/amandemen/revision?credentials=${localStorage.getItem('credential')}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const resubmitAmandemen = (data) => {
  return api.put(`/amandemen/resubmit?credentials=${localStorage.getItem('credential')}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

export {
  getAmandemen,
  detailAmandemen,
  createAmandemen,
  approveAmandemen,
  rejectAmandemen,
  orderDetailAmandemen,
  detailAmandemenCustomer,
  reviseAmandemen,
  resubmitAmandemen,
}
